import '../styles/Skeleton.css';

/**
 * Loading placeholders. Each shape mirrors the box of the real content so the
 * page does not jump when data arrives.
 */

/**
 * `as` exists because the inline variant is used inside <p> and <span>, and a
 * <div> there is invalid HTML — React renders it, but the markup is malformed
 * and breaks under any HTML-parsing path.
 */
const Skeleton = ({ className = '', style, as: Tag = 'div' }) => (
  <Tag className={`skeleton ${className}`.trim()} style={style} aria-hidden="true" />
);

/** Delay for staggered entrances, capped so long lists finish within ~300ms. */
export const staggerStyle = (index, cap = 6) => ({
  '--i': Math.min(index, cap),
});

export const SkeletonChannelRow = () => (
  <div className="skeleton-channel-row">
    <Skeleton className="skeleton--avatar-sm" />
    <Skeleton className="skeleton--text" style={{ width: '60%', marginBottom: 0 }} />
  </div>
);

export const SkeletonStaffCard = () => (
  <div className="skeleton-staff-card">
    <Skeleton className="skeleton--avatar" />
    <div className="skeleton-lines">
      <Skeleton className="skeleton--text" style={{ width: '70%' }} />
      <Skeleton className="skeleton--text" style={{ width: '40%', marginBottom: 0 }} />
    </div>
  </div>
);

export const SkeletonAnnouncement = () => (
  <div className="skeleton-card">
    <Skeleton className="skeleton--title" />
    <Skeleton className="skeleton--text" />
    <Skeleton className="skeleton--text" style={{ width: '92%' }} />
    <Skeleton className="skeleton--text" style={{ width: '78%', marginBottom: 0 }} />
  </div>
);

export const SkeletonChangelogRow = () => (
  <div className="skeleton-card">
    <Skeleton className="skeleton--text" style={{ width: '85%' }} />
    <Skeleton className="skeleton--text" style={{ width: '35%', marginBottom: 0 }} />
  </div>
);

/** Repeats a shape `count` times. */
export const SkeletonList = ({ count, children }) =>
  Array.from({ length: count }, (_, i) => <div key={i}>{children}</div>);

export default Skeleton;
